export const formatCurrency = (num) =>
  `$${num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;

const flags = {
  af: "ZA",
  ar: "EG",
  az: "AZ",
  be: "BY",
  bg: "BG",
  bs: "BA",
  ca: "ES",
  cs: "CZ",
  cy: "GB",
  da: "DK",
  de: "DE",
  dv: "MV",
  el: "GR",
  en: "US",
  es: "ES",
  et: "EE",
  eu: "ES",
  fa: "IR",
  fi: "FI",
  fo: "FO",
  fr: "FR",
  gl: "ES",
  gu: "IN",
  he: "IL",
  hi: "IN",
  hr: "HR",
  hu: "HU",
  hy: "AM",
  id: "ID",
  is: "IS",
  it: "IT",
  ja: "JP",
  ka: "GE",
  kk: "KZ",
  kn: "IN",
  ko: "KR",
  kok: "IN",
  ky: "KG",
  lt: "LT",
  lv: "LV",
  mi: "NZ",
  mk: "MK",
  mn: "MN",
  mr: "IN",
  ms: "MY",
  mt: "MT",
  nb: "NO",
  nl: "NL",
  nn: "NO",
  pa: "IN",
  pl: "PL",
  ps: "AF",
  pt: "BR",
  qu: "PE",
  ro: "RO",
  ru: "RU",
  sa: "IN",
  se: "NO",
  sk: "SK",
  sl: "SI",
  sq: "AL",
  sr: "RS",
  sv: "SE",
  sw: "TZ",
  syr: "IQ",
  ta: "IN",
  te: "IN",
  th: "TH",
  tl: "PH",
  tn: "ZA",
  tr: "TR",
  tt: "RU",
  ts: "ZA",
  uk: "UA",
  ur: "PK",
  uz: "UZ",
  vi: "VN",
  xh: "ZA",
  zh: "CN",
  "zh-HK": "HK",
  "zh-MO": "MO",
  "zh-TW": "TW",
  zu: "ZA",
};

export const isoToFlag = (iso) => {
  let code = flags[iso];

  if (!code) {
    code = flags[iso.split("-").shift()];
  }

  if (!code) {
    return null;
  }

  const a = String.fromCodePoint(code.codePointAt(0) - 0x41 + 0x1f1e6);
  const b = String.fromCodePoint(code.codePointAt(1) - 0x41 + 0x1f1e6);

  return a + b;
};
